module.exports = __webpack_public_path__ + "static/img/4.2385a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.png
// module id = q/uz
// module chunks = 10